import { deleteRequest, patchRequest, postRequest } from 'utils/api'
import {
  COHORTS_URL,
  COHORT_GOAL_FACILITATION_URL,
  COHORT_SESSIONS_URL,
  GOAL_TIMELINES_URL
} from './constants'

export const postCohort = async requestBody => {
  const res = await postRequest(COHORTS_URL, requestBody)
  const result = { error: true }
  if (res.status === 201) {
    result.error = false
    result.data = res.data.data
  } else if (res.status === 422) {
    result.message = 'Name has been taken, please update cohort name and retry.'
  }
  return result
}

export const patchCohort = async (cohortId, requestBody) => {
  const res = await patchRequest(`${COHORTS_URL}/${cohortId}`, requestBody)
  return res
}

export const postPatchSession = async (requestBody, cohortSessionId) => {
  const res = cohortSessionId
    ? await patchRequest(
        `${COHORT_SESSIONS_URL}/${cohortSessionId}`,
        requestBody
      )
    : await postRequest(COHORT_SESSIONS_URL, requestBody)
  const result = { error: true }
  if (res.status === 201 || res.status === 200) {
    result.error = false
    result.data = res.data.data
  } else if (res.status === 422) {
    result.message =
      'Session dates might be overlapping with other session in cohort. Please double check.'
  }
  return result
}

const updateFacilitation = async (fac, goalTimelineId) => {
  return patchRequest(`${COHORT_GOAL_FACILITATION_URL}/${fac.id}`, {
    userId: fac.userId || '',
    facilitationDate: fac.facilitationDate,
    goalTimelineId
  })
}

export const updateFacilitations = async (cohortSessionId, facilitations) => {
  // Use facilitation flags for update and delete
  // Also manage customized goal timeline create/update/delete
  // If facilitation is deleting, delete customized goal timeline after
  // If facilitation is creating, create customized goal timeline first
  const results = await Promise.all(
    facilitations.map(async fac => {
      // Handle existing deletion
      let res
      if (fac.deleting && fac.id) {
        res = await deleteRequest(`${COHORT_GOAL_FACILITATION_URL}/${fac.id}`)
        if (res.status !== 204) {
          return res
        }
      }

      if (fac.goalTimeline?.id && fac.goalTimeline.deleting) {
        if (!fac.deleting && fac.goalTimelineId !== fac.goalTimeline.id) {
          res = await updateFacilitation(fac, fac.goalTimelineId)
        }
        res = await deleteRequest(
          `${GOAL_TIMELINES_URL}/${fac.goalTimeline.id}`
        )
        if (res.status !== 204) {
          return res
        }
      } else {
        // Handle updating/creating goal timeline
        let newGoalTimelineId = null
        if (fac.goalTimeline) {
          if (fac.goalTimeline.id && fac.goalTimeline.updating) {
            res = await patchRequest(
              `${GOAL_TIMELINES_URL}/${fac.goalTimeline.id}`,
              {
                preFacilitationEmail: fac.goalTimeline.preFacilitationEmail
              }
            )
            if (res.status !== 200) {
              return res
            }
          }
          
          if (!fac.goalTimeline.id) {
            
            res = await postRequest(GOAL_TIMELINES_URL, {
              goalId: fac.goalTimeline.goalId,
              endGoalStepId: fac.goalTimeline.endGoalStepId,
              number: fac.goalTimeline.number,
              preFacilitationEmail: fac.goalTimeline.preFacilitationEmail,
              cohortSessionId
            })
            if (res.status !== 201) {
              return res
            }
            newGoalTimelineId = res.data.data.id
          }
        }
        // Handle facilitation update/create
        if (fac.id && fac.updating && fac.facilitationDate) {
          res = await updateFacilitation(fac, newGoalTimelineId || fac.goalTimelineId)
        }
        if (!fac.id) {
          return postRequest(COHORT_GOAL_FACILITATION_URL, {
            cohortSessionId,
            userId: fac.userId,
            facilitationDate: fac.facilitationDate,
            goalTimelineId: fac.goalTimelineId || newGoalTimelineId
          })
        }
      }
      return res
    })
  )
  const failedRequest = results.find(
    res =>
      res?.status &&
      res.status !== 200 &&
      res.status !== 201 &&
      res.status !== 204
  )
  if (failedRequest) {
    return {
      error: true,
      message:
        'Facilitations update failed. Please check if all dates are between session start date and end date.'
    }
  }
  return { error: false }
}
